import { render, staticRenderFns } from "./ShowcaseDashboard.vue?vue&type=template&id=49e2336b"
import script from "./ShowcaseDashboard.vue?vue&type=script&lang=js"
export * from "./ShowcaseDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports